import { FC } from 'react';
import { classes, stylesheet } from 'typestyle';
import {
  BlackOpacity04,
  Black,
  ButtonIcon,
  Gray10,
  Gray100,
  Gray150,
  TextInput,
  typeCompact14MediumProperties,
  typeCompact12RegularProperties,
  typeCompact12MediumProperties,
  typeCompact14RegularProperties,
} from '@traceair/tds';
import { MinusIcon } from '@traceair/webapp-icons';
import { numericOnly } from '../InvoicingUtils';

const css = stylesheet({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 16px 8px 108px',
    borderBottom: `1px solid ${Gray10}`,
    backgroundColor: BlackOpacity04,
    height: 40,
    ...typeCompact14RegularProperties,
  },
  rowReadOnly: {
    padding: '8px 24px 8px 144px !important',
  },
  rowTimeMaterials: {
    padding: '4px 16px 4px 104px',
    boxSizing: 'border-box',
    ...typeCompact12RegularProperties,
  },
  label: {
    flex: 1,
    color: Gray150,
  },
  priceInputContainer: {
    flexShrink: 0,
    $nest: {
      '& input': { ...typeCompact12MediumProperties, textAlign: 'right' as const },
      '& .ta-text-input': { width: 90, minHeight: 32, height: 32 },
      '& .ta-text-input div': { ...typeCompact12MediumProperties, top: 10 },
    },
  },
  readOnlyAmount: {
    flexShrink: 0,
    ...typeCompact14MediumProperties,
    color: Black,
  },
});

type Props =
  | { readOnly: true; label: string; amount: number; timeMaterials?: boolean }
  | {
      readOnly?: false;
      label: string;
      amount: string;
      onAmountChange: (value: string) => void;
      onRemove: () => void;
      timeMaterials?: boolean;
    };

export const GcpMaterialRow: FC<Props> = (props) => {
  if (props.readOnly) {
    return (
      <div
        className={classes(css.row, css.rowReadOnly, props.timeMaterials && css.rowTimeMaterials)}
        style={props.timeMaterials ? { paddingLeft: 68 } : undefined}
      >
        <div className={css.label}>{props.label}</div>
        <span className={css.readOnlyAmount}>${props.amount.toLocaleString()}</span>
      </div>
    );
  }
  return (
    <div className={classes(css.row, props.timeMaterials && css.rowTimeMaterials)}>
      <ButtonIcon
        icon={<MinusIcon size={14} color={Gray100} />}
        size="xs"
        style="tertiary"
        type="black"
        onClick={props.onRemove}
      />
      <div className={css.label}>{props.label}</div>
      <div className={css.priceInputContainer}>
        <TextInput
          leftCell={props.amount ? '$' : undefined}
          value={props.amount}
          placeholder="Price"
          onChange={(val) => props.onAmountChange(numericOnly(val))}
        />
      </div>
    </div>
  );
};
